import React from "react";
import TextInput from "../../Components/Inputs/TextInput";
import EmailInput from "../../Components/Inputs/EmailInput";
import DateInput from "../../Components/Inputs/DateInput";
import ImageInput from "../../Components/Inputs/ImageInput";
import Switch from "../../Components/Inputs/Switch";

export default function ({register, watch, errors, control}) {
  return (
    <>
      <ImageInput
        name="avatar"
        parentClasses="col-md-12"
        classes="d-inline-block"
        register={register}
        control={control}
        errorMessage={errors?.avatar}
      />

      <Switch
        label="Legal Entity"
        name="is_legal"
        parentClasses="col-md-12 mt-10 active-notactive"
        register={register}

      />

      <TextInput
        label={!watch('is_legal') ? "First Name" : "Name"}
        name="first_name"
        parentClasses="col-md-6"
        register={register}
        required={true}
        errorMessage={errors?.first_name}
      />

      {
        !watch('is_legal') && (
          <>
            <TextInput
              label="Last Name"
              name="last_name"
              parentClasses="col-md-6"
              register={register}
              required={true}
              errorMessage={errors?.last_name}
            />

            <DateInput
              label="Birthday"
              name="birthday"
              parentClasses="col-md-6"
              register={register}
              errorMessage={errors?.birthday}
            />

            <TextInput
              label="Personal Number"
              name="personal_number"
              parentClasses="col-md-6"
              register={register}
              errorMessage={errors?.personal_number}
            />
          </>
        )
      }

      {
        watch('is_legal') && (
          <TextInput
            label="Identification code"
            name="identification_code"
            parentClasses="col-md-6"
            register={register}
            required={true}
            errorMessage={errors?.identification_code}
          />
        )
      }

      <TextInput
        label="Phone"
        name="phone"
        parentClasses="col-md-6"
        register={register}
        errorMessage={errors?.phone}
      />

      <EmailInput
        label="Email"
        name="email"
        parentClasses="col-md-6"
        register={register}
        errorMessage={errors?.email}
      />
    </>
  );
}